import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Upload, Icon, Checkbox } from "antd";
import { Row, Col, Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import ResizeObserver from 'resize-observer-polyfill';
import "react-block-ui/style.css";
import { useForm } from "react-hook-form";
import "antd/dist/antd.css";
import _ from "lodash";
import ReviewService from "../../../../services/screens/admin/composition/management/ReviewService";
import AudioRecorder from "../../../../components/ui/AudioRecorder";
import MessageBox from "../../../../components/ui/MessageBox";
import UnitAIView from "../../../../components/units/ai/UnitAIView";
import HtmlField from "../../unit/fields/types/HtmlField";
import HTMLView from "../../../../components/ui/HTMLView";
import { ReplaceUrlWithVirtualPath, ToolBarAffix } from "../../../../components/ui/HTMLEditor";
import * as Helper from "../../../../utils/Helper";
import UIDs from "../../../../UIDs";
import Constants from "../../../../config/Constants";
import dayjs from "../../../../utils/dayjs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const uid = UIDs.screens.admin.composition.management.review;

const ReviseDetail = (props) => {
    const { t } = useTranslation(uid);
    const { userHomeworkId, unit } = props;
    const { userHomeworkUnitId, userHomeworkPeerRevises } = unit;

    const [state_historyModal, setstate_historyModal] = useState(false);
    const [state_historyData, setstate_historyData] = useState(null);
    const [state_avgScore, setstate_avgScore] = useState(0);

    useEffect(() => {
        let avgScore = "-";
        let scoreCount = 0;
        if (userHomeworkPeerRevises) {
            let total = 0;
            _.each(userHomeworkPeerRevises, (item) => {
                if (!_.isNull(item.score) && _.isNumber(item.score) && item.score >= 0) {
                    total += item.score * 100;
                    scoreCount += 1;
                }
            });
            avgScore = scoreCount > 0 ? parseInt(total / scoreCount) : "-";
        }
        setstate_avgScore(avgScore);
    }, [userHomeworkPeerRevises]);
    const showHistory = (data) => {
        setstate_historyData(data);
        setstate_historyModal(true);
    };

    let userCount = 0;
    userHomeworkPeerRevises.map((it) => {
        if (it.revisedOn) {
            userCount += 1;
        }
    });

    const renderHistory = () => {
        return (
            <table className="table border ">
                <thead>
                    <tr>
                        <th scope="col">{t("resiveUser")}</th>
                        <th scope="col">{t("peerScore")}</th>
                        <th scope="col">{t("peerDate")}</th>
                        <th scope="col">{t("action")}</th>
                    </tr>
                </thead>
                <tbody>
                    {userHomeworkPeerRevises && userHomeworkPeerRevises.length > 0 && userCount > 0 ? (
                        userHomeworkPeerRevises.map((it, i) => {
                            if (!it.revisedOn) {
                                return null;
                            }
                            return (
                                <tr key={i}>
                                    <td>{it.userName}</td>
                                    <td>{it.score !== null && it.score >= 0 ? (it.score * 100).toFixed(0) : "-"}</td>
                                    <td>{it.revisedOn ? dayjs.utc(it.revisedOn).local().format("YYYY-MM-DD HH:mm") : "- -"}</td>
                                    <td>
                                        <a href="javascript:void(0)" onClick={() => showHistory(it, i)}>
                                            {t("seeDetails")}
                                        </a>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan={4} style={{textAlign:"center"}}>{t("noPeerResive")}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    };

    const renderHistoryDetail = () => {
        const historyUnit = {
            ...unit,
            score: state_historyData.score,
            comments: state_historyData.comments,
        };
        return (
            <CommentsDetails
                key={unit.userHomeworkUnitId}
                {...props}
                userHomeworkId={userHomeworkId}
                unitIndex={0}
                unitCount={1}
                unit={historyUnit}
                hideBottom={true}
                isHistory={true}
                //onPrevious={this._handlePrevious}
                //onNext={this._handleNext}
                //onSaveAiScore={this._handleSaveAiScore}
            />
        );
    };

    return (
        <>
            <hr style={{ width: "100%", marginTop: "12px", marginBottom: "12px" }} />
            <div style={{ alignSelf: "start", width: "100%", marginBottom: "20px" }}>
                <h4 style={{ fontWeight: "bold" }}>
                    {t("peerResiveTitle", { count: userCount, score: state_avgScore })}
                    {(unit.returned || (!unit.endOn)) ? null :
                     (<Button color="primary" size="sm" style={{marginLeft: 20}}
                              onClick={() => props.onRedoUnit(userHomeworkUnitId, true)}>
                          {t("redoIt")}
                      </Button>)}
                </h4>
                {renderHistory()}
                <Modal size={"lg"} isOpen={state_historyModal}>
                    <ModalHeader className="aic-modal-header" style={{ padding: "10px 10px 5px", height: "40px" }} toggle={() => setstate_historyModal(false)} charCode="X">
                        <h3>
                            {t("resiveUser")} {state_historyData ? state_historyData.userName : null} {state_historyData && state_historyData.revisedOn ? dayjs.utc(state_historyData.revisedOn).local().format("YYYY-MM-DD HH:mm") : null}
                        </h3>
                    </ModalHeader>
                    <ModalBody style={{ padding: "0.5rem" }}>{state_historyData ? renderHistoryDetail() : null}</ModalBody>
                </Modal>
            </div>
        </>
    );
};

const HistoryPart = (props) => {
    const { t } = useTranslation(uid);
    const { historyOnly, isHistory, userHomeworkId, unit } = props;

    const comments = unit.comments ? JSON.parse(unit.comments) : "" || { unitScreenShot: {} };
    const { history } = comments;

    const historyObjArr = history
        ? _.map(history, (item) => {
              try {
                  return JSON.parse(item);
              } catch (e) {
                  console.error(e);
                  return item;
              }
          })
        : [];

    if (historyOnly && (!isHistory)) {
        if ((comments.score !== null && comments.score !== undefined) || comments.addedOn) {
            historyObjArr.push(comments);
        }
    }

    const [state_historyModal, setstate_historyModal] = useState(false);
    const [state_historyData, setstate_historyData] = useState(null);
    const showHistory = (data) => {
        setstate_historyData(data);
        setstate_historyModal(true);
    };

    const renderHistory = () => {
        return (
            <table className="table border ">
                <thead>
                    <tr>
                        <th scope="col">{t("reviewTime")}</th>
                        <th scope="col">{t("otherScore")}</th>
                        <th scope="col">{t("action")}</th>
                    </tr>
                </thead>
                <tbody>
                    {historyObjArr.map((it, i) => (
                        <tr key={i}>
                            <td>{dayjs(it.addedOn).format("YYYY-MM-DD HH:mm")}</td>
                            <td>{/*(it.score !== null && it.score >= 0) ? (it.score * 100).toFixed(0) : "-"*/}
                                {it.otherScore ? it.otherScore : Helper.isNullOrUndefined(it.score) ? "" : (it.score !== null && it.score >= 0) ? (it.score * 100).toFixed(0) : "-"}
                            </td>
                            <td>
                                <a href="javascript:void(0)" onClick={() => showHistory(it, i)}>
                                    {t("seeDetails")}
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    const renderHistoryDetail = () => {
        const historyUnit = {
            ...unit,
            score: state_historyData.score,
            comments: JSON.stringify(state_historyData),
            answer: JSON.stringify({
                answers: state_historyData.text,
            }),
        };
        return (
            <CommentsDetails
                key={unit.userHomeworkUnitId}
                {...props}
                userHomeworkId={userHomeworkId}
                unitIndex={0}
                unitCount={1}
                unit={historyUnit}
                hideBottom={true}
                isHistory = {true}
                //onPrevious={this._handlePrevious}
                //onNext={this._handleNext}
                //onSaveAiScore={this._handleSaveAiScore}
            />
        );
    };

    return historyObjArr && historyObjArr.length > 0 ? (
        <>
            <hr style={{ width: "100%", marginTop: "12px", marginBottom: "12px" }} />
            <div style={{ alignSelf: "start", width: "100%", marginBottom: "20px" }}>
                <h4 style={{ fontWeight: "bold" }}>{t("reviewHistory")}</h4>
                {renderHistory()}
                <Modal size={"lg"} isOpen={state_historyModal}>
                    <ModalHeader className="aic-modal-header" style={{ padding: "10px 10px 5px", height: "40px" }} toggle={() => setstate_historyModal(false)} charCode="X">
                        <h3>
                            {t("reviewHistory")} {state_historyData && state_historyData.revisedOn ? dayjs.utc(state_historyData.revisedOn).local().format("YYYY-MM-DD HH:mm") : null}
                        </h3>
                    </ModalHeader>
                    <ModalBody style={{ padding: "0.5rem" }}>{state_historyData ? renderHistoryDetail() : null}</ModalBody>
                </Modal>
            </div>
        </>
    ) : null;
};

const CommentsDetails = (props) => {
    const { t } = useTranslation(uid);
    const { onPrevious, onNext, unit, unitIndex, unitCount, fullName, homeworkName, homeworkStatus, reviseMode, historyOnly, isHistory } = props;

    const { userHomeworkUnitId, unitType, cover, score, answer, files, childUnitIndex, isSubjective, needRevise } = unit;
    const { comments, unitScreenShot, audioPath, aiData, text, html, history, scoreFile, otherScore } = unit.comments ? JSON.parse(unit.comments) : "" || {};
    const data = { ...unit.data, userHomeworkUnitId, childUnitIndex };
    const result = answer ? { score, answer: JSON.parse(answer), files: JSON.parse(files) } : null;

    const submitAiScoreRef = useRef();
    const { register, handleSubmit, errors, clearError } = useForm();

    if (historyOnly && (!isHistory)) {
        return (<div>
                    <Row>
                        <Col>
                            <div style={{ margin: "0 auto", width: "100%" }}>
                                <UnitAIView
                                    compositionMode={true}
                                    unitType={unitType}
                                    unitData={data}
                                    answer={answer}
                                    homeworkName={homeworkName}
                                    fullName={fullName}
                                    unitIndex={unitIndex}
                                    width={"100%"}
                                    //height={525}
                                    data={aiData}
                                    html={html}
                                    readonly={true}
                                    reviseMode = {reviseMode}
                                    hideAnswer={true}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                <HistoryPart {...props} />
                                {props.hideBottom ? null : (
                                    <div style={{ margin: "20px auto" }}>
                                        {unitIndex > 0 && (
                                            <Button color="primary" onClick={() => onPrevious()}>
                                                {t("previous")}
                                            </Button>
                                        )}
                                        {unitIndex + 1 === unitCount ? null : (
                                            <Button color="primary" onClick={() => onNext()}>
                                                {t(unitIndex + 1 === unitCount ? "complete" : "next")}
                                            </Button>
                                        )}
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                </div>);
    }

    const isHtmlComments = comments && comments.trim().startsWith("<p>") && comments.trim().endsWith("</p>");
    return (
        <form onSubmit={handleSubmit(props.onSaveAiScore)}>
            <input name="userHomeworkUnitIdAiScore" hidden type="text" className="form-control" defaultValue={userHomeworkUnitId} ref={register} />
            <Row>
                <Col>
                    <div style={{ margin: "0 auto", width: "100%" }}>
                        <UnitAIView
                            compositionMode={true}
                            unitType={unitType}
                            unitData={data}
                            answer={answer}
                            homeworkName={homeworkName}
                            fullName={fullName}
                            unitIndex={unitIndex}
                            width={"100%"}
                            //height={525}
                            data={aiData}
                            html={html}
                            readonly={true}
                            reviseMode = {reviseMode}
                        />
                    </div>
                </Col>
            </Row>
            <hr style={{ marginTop: "8px", marginBottom: "8px" }} />
            <Row>
                <Col>
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                        <div style={{ alignSelf: "start", width: "100%" }}>
                            {needRevise ? (
                                <>
                                    {comments && (
                                        <>
                                            {isHtmlComments ? (<HTMLView style={{border: '1px solid #ccc', padding: 10, margin: "10px 0", borderRadius: 6, backgroundColor: '#f2f2f2'}} html={comments}/>) : null}
                                            {isHtmlComments ? (<input type="hidden" name="comments"
                                                                      defaultValue={comments}/>) : null}
                                            {isHtmlComments ? null :
                                             (<textarea
                                               style={{ margin: "10px 0" }}
                                               rows="4"
                                               type="text"
                                               name="comments"
                                               className="form-control-alternative form-control"
                                               defaultValue={comments}
                                               disabled
                                              />)}
                                            </>
                                    )}
                                    {audioPath && (
                                        <>
                                        <div style={{ margin: "10px 0" }}>
                                            <div style={{float:"left", marginRight:10}}>
                                            <audio controls type="audio/mpeg" src={Helper.convertToFileServerPath(audioPath)}>
                                                Your browser does not support the audio element.
                                            </audio>
                                            </div>
                                            <Button
                                                style={{float:"left", marginTop:5}}
                                                color="primary"
                                                onClick={()=>{Helper.downloadFile(Helper.convertToFileServerPath(audioPath), Helper.getLastFileName(audioPath))}}
                                            >
                                                {t("download")}
                                            </Button>
                                        </div>
                                        <div style={{ clear:"both", }}></div>
                                        </>
                                    )}
                                    {!(score === -1 || score === -2) && (
                                        <div style={{ margin: "10px 0" }}>
                                            {otherScore ? <label className="form-control-label">
                                                <>
                                                    {t("otherScore")}：
                                                    <div style={{marginBottom: 10, fontWeight:"normal", color:"red"}}>{otherScore}</div>
                                                </>
                                                {unit.returned ? null :
                                                 (isHistory ? null : <Button color="primary" style={{marginLeft: 0}}
                                                          onClick={() => props.onRedoUnit(userHomeworkUnitId, true)}>
                                                      {t("redoIt")}
                                                  </Button>)}
                                            </label>
                                            :
                                            Helper.isNullOrUndefined(score) ? "" : <label className="form-control-label">
                                                {t("reviewScore")}
                                                {props.isHistory ?<label className="form-control-label" style={{ color: "#ea0000" }}>
                                                    {!Helper.isNullOrUndefined(score) && score >= 0 ? (score * 100).toFixed(0) : "-"}
                                                </label>:
                                                <><input
                                                    type="text"
                                                    disabled={true}
                                                    name="aiscore"
                                                    className="form-control-alternative form-control"
                                                    style={{ borderColor: errors.score ? "red" : "", width: 60, display: "inline", marginLeft: 5, marginRight: 5 }}
                                                      defaultValue={score !== null ? (score * 100).toFixed(0) : ''}
                                                    ref={register({
                                                        validate: {
                                                            message: (_value) => {
                                                                let value = _value ? _value.trim() : "";
                                                                let reg = /^\d{1,3}$/;
                                                                if (!reg.test(value)) {
                                                                    return t("scoreFieldIsRequired");
                                                                }

                                                                if (value < 0 || value > 100) {
                                                                    return t("scoreFieldIsRequired");
                                                                }
                                                                return clearError();
                                                            },
                                                        },
                                                    })}
                                                />
                                                {/*<Button
                                                    color="primary"
                                                    disabled={props.isDisabled}
                                                    onClick={() => {
                                                        submitAiScoreRef.current.click();
                                                    }}>
                                                    {t("save")}
                                                </Button>*/}
                                                {errors.aiscore && <span className="text-danger">{errors.aiscore.message}</span>}
                                                {unit.returned ? null :
                                                 (<Button color="primary" style={{marginLeft: 0}}
                                                          onClick={() => props.onRedoUnit(userHomeworkUnitId, true)}>
                                                      {t("redoIt")}
                                                  </Button>)}
                                                </>}
                                            </label>}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <label style={{ margin: "10px 0" }} className="form-control-label">
                                    {t("aiscore")}
                                    {/*<label className="form-control-label" style={{ color: "red" }}>{(score * 100).toFixed(0)}</label>*/}
                                    <input
                                        type="text"
                                        name="aiscore"
                                        className="form-control-alternative form-control"
                                        style={{ borderColor: errors.score ? "red" : "", width: 60, display: "inline", marginLeft: 5, marginRight: 5 }}
                                        defaultValue={(score * 100).toFixed(0)}
                                        ref={register({
                                            validate: {
                                                message: (_value) => {
                                                    let value = _value ? _value.trim() : "";
                                                    let reg = /^\d{1,3}$/;
                                                    if (!reg.test(value)) {
                                                        return t("scoreFieldIsRequired");
                                                    }

                                                    if (value < 0 || value > 100) {
                                                        return t("scoreFieldIsRequired");
                                                    }
                                                    return clearError();
                                                },
                                            },
                                        })}
                                    />
                                    <Button
                                        color="primary"
                                        disabled={props.isDisabled}
                                        onClick={() => {
                                            submitAiScoreRef.current.click();
                                        }}>
                                        {t("save")}
                                    </Button>
                                    {errors.aiscore && <span className="text-danger">{errors.aiscore.message}</span>}
                                    {unit.returned ? null :
                                     (<Button color="primary" style={{marginLeft: 0}}
                                              onClick={() => props.onRedoUnit(userHomeworkUnitId, true)}>
                                          {t("redoIt")}
                                      </Button>)}
                                </label>
                            )}
                            <div>
                                {scoreFile
                                    ? scoreFile.map((item, i) => {
                                          const maxWidth = props.width ? props.width - 120 : 200;
                                          return (
                                              <div key={i} style={{paddingBottom:20}}>
                                                  <div>
                                                      <a
                                                          target="_blank"
                                                          href={Helper.convertToFileServerPath(item.path)}
                                                          style={{
                                                              padding: !item.path.match(/\.(jpg|jpeg|png|gif)$/i) ? "10px 25px" : "10px 0px",
                                                              backgroundColor: !item.path.match(/\.(jpg|jpeg|png|gif)$/i) ? "#FFBD3F" : undefined,
                                                              borderRadius:6,
                                                              whiteSpace: "nowrap",
                                                              textOverflow: "ellipsis",
                                                              maxWidth: maxWidth,
                                                              overflow: "hidden",
                                                              marginBottom: 8,
                                                              color: !item.path.match(/\.(jpg|jpeg|png|gif)$/i) ? "#fff" : "#3179f4",
                                                              marginRight: 4,
                                                          }}
                                                          rel="noreferrer">
                                                          {item.name}
                                                      </a>
                                                  </div>
                                                  <div>
                                                      {!item.path.match(/\.(jpg|jpeg|png|gif)$/i) ? null : (
                                                          <a target="_blank" href={Helper.convertToFileServerPath(item.path)} style={{ marginTop: 4, display: "block" }} rel="noreferrer">
                                                              <img src={Helper.convertToFileServerPath(item.path)} style={{ maxWidth: "70%" }} alt={item.name} />
                                                          </a>
                                                      )}
                                                  </div>
                                              </div>
                                          );
                                      })
                                    : null}
                            </div>
                        </div>
                        {isHistory ? null : (<HistoryPart {...props} />)}
                        {props.hideBottom ? null : (
                            <div style={{ margin: "20px auto" }}>
                                {unitIndex > 0 && (
                                    <Button color="primary" onClick={() => onPrevious()}>
                                        {t("previous")}
                                    </Button>
                                )}
                                {unitIndex + 1 === unitCount ? null : (
                                    <Button color="primary" onClick={() => onNext()}>
                                        {t(unitIndex + 1 === unitCount ? "complete" : "next")}
                                    </Button>
                                )}
                            </div>
                        )}
                    </div>
                </Col>
            </Row>
            <input ref={submitAiScoreRef} type="submit" hidden />
        </form>
    );
};

const CommentsForm = (props) => {
    const { t } = useTranslation(uid);
    const { onPrevious, onNext, onTempSave, userHomeworkId, unit, unitIndex, unitCount, reviseMode, fullName, homeworkName } = props;
    const { userHomeworkUnitId, unitType, score: unitScore, answer, files, childUnitIndex } = unit;

    const data = { ...unit.data, userHomeworkUnitId, childUnitIndex };
    const homeworkResult = answer ? { score: unit.score, answer: JSON.parse(answer), files: JSON.parse(files) } : null;

    const uploadScoreFileProps = {
        name: "fileData",
        showUploadList: false, // set to only upload one file
        customRequest: (info) => {
            const { userId, partnerId } = props;
            const now = new Date();
            const uploadPath = `${Constants.FILE_STORAGE.TEMP_PATH}users/${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}/${userId}/${userHomeworkUnitId}`;
            setstate_uploading(true);
            ReviewService.uploadAudio(
                info.file,
                uploadPath,
                partnerId,
                (response) => {
                    const { virtualPath } = response;
                    setstate_uploadScoreFiles([
                        ...state_uploadScoreFiles,
                        {
                            path: virtualPath,
                            name: info.file.name,
                        },
                    ]);
                    setstate_uploading(false);
                },
                (error) => {
                    MessageBox.danger({ text: error.message, duration: 5000 });
                }
            );
            // props.uploadAudioAsync(info.file);
        },
        beforeUpload: (file) => {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                MessageBox.danger({ text: t("uploadAudioSizeLimited", { fileSize: 2 }), duration: 5000 });
                return false;
            }
            return isLt2M;
        },
    };

    const comments = unit.comments ? JSON.parse(unit.comments) : "" || { unitScreenShot: {} };
    const { unitScreenShot, audioPath, aiData, text, html, history, scoreFile, otherScore } = comments;
    const aiViewRef = useRef();
    const submitRef = useRef();
    const editorViewRef = useRef();
    const affixViewRef = useRef();
    const formMethods = useForm();
    const { register, handleSubmit, errors, clearError, getValues, setError, triggerValidation } = formMethods;

    const [state_audioRecord, setstate_audioRecord] = useState(false);
    const [state_audioPath, setstate_audioPath] = useState(audioPath);
    const [state_uploadScoreFiles, setstate_uploadScoreFiles] = useState(scoreFile ? scoreFile : []);
    const [state_previous, setstate_previous] = useState(false);
    const [state_redo, setstate_redo] = useState(unitScore === -2);
    let redoDate = null;
    if (unitScore === -2 && comments.newDueTime) {
        redoDate = dayjs(comments.newDueTime);
    }
    const [state_redoDate, setstate_redoDate] = useState(redoDate ? redoDate.toDate() : "");
    const [state_reddTime, setstate_reddTime] = useState(redoDate ? redoDate.toDate() : "");
    const [state_direction, setstate_direction] = useState(0);
    const [state_uploading, setstate_uploading] = useState(false);
    const [state_aiEdit, setstate_aiEdit] = useState(false);
    const [state_CommentData, setstate_state_CommentData] = useState(comments);

    useEffect(() => {
        if (state_direction) {
            submitRef.current.click();
            setstate_direction(0);
        }
    }, [state_direction]);

    const getDefaultScore = () => {
        let targetScore = unit.score;
        if (unit.score === -2) {
            targetScore = comments.score;
        }
        return !_.isNull(targetScore) ? (targetScore === 0 ? 0 : targetScore > 0 && targetScore < 1 ? (targetScore * 100).toFixed(0) : "") : "";
    };

    const handleSubmitComments = (data, e) => {
        if (state_audioRecord) {
            MessageBox.danger({ text: props.t('pleaseStopAudioRecordFirst'), duration: 5000 });
            return;
        }

        let commentsResult = {
            unitScreenShot: {
                uri: null,
                height: 720,
                width: 400,
                handwriteExistence: false,
            },
            handWriteDraw: JSON.stringify({ lines: [], width: 400, height: 720 }),
        };

        if (homeworkResult) {
            commentsResult.text = homeworkResult.answer.answers;
        }
        if (history) {
            commentsResult.history = history;
        }
        if (aiData) {
            commentsResult.aiData = aiData;
        }
        if (state_CommentData.html) {
            commentsResult.html = ReplaceUrlWithVirtualPath(state_CommentData.html);
        } else {
            if (aiViewRef.current) {
                commentsResult.html = aiViewRef.current.getHtml();
            }
        }
        if (state_uploadScoreFiles) {
            commentsResult.scoreFile = state_uploadScoreFiles;
        }

        let score = -1; // -1 indicates "skip"
        //score = data.score / 100;     //此行屏蔽，添加otherScore,记录老师随意添加的评分 AIC-5-1177
        score = null;
        //如果评分只填了数字，则记录到score字段，如果没填，则为空，如果随便填的，则将score设置为-9
        if(Helper.isNumeric(data.otherScore)){
            score = parseInt(data.otherScore) / 100;
        } else if(!Helper.isNullOrEmpty(data.otherScore)){
            score = -9;
        }

        commentsResult.otherScore = data.otherScore;
        if (state_direction == 2) {
            if (!(parseInt(data.score) >= 0)) {
                score = null;
            }
        }

        commentsResult.comments = ReplaceUrlWithVirtualPath(data.comments);
        commentsResult.audioPath = state_audioPath;
        commentsResult.score = score;

        let result = null;
        commentsResult.addedOn = dayjs().toISOString();
        if (state_redo) {
            //重做的情况直接把当前的comments存为history, 在server端保存history
            if (state_redoDate && state_reddTime) {
                commentsResult.newDueTime = new Date(state_redoDate.setHours(state_reddTime.getHours()));
            }

            commentsResult.score = score;
            //commentsResult.aiData = ""; //clear me
            score = -2;
        }

        result = { userHomeworkUnitId, comments: commentsResult ? JSON.stringify(commentsResult) : "", score };

        if (state_direction === 2) {
            onTempSave(result);
            return;
        } else if (state_direction === 1) {
            if (unit.revisedOn && unit.comments === result.comments && (unit.score === result.score || (unit.score === null && result.score == -1))) {
                result = null;
            }
            onNext(result);
        } else if (state_direction === -1) {
            //onPrevious(result);
            //点击上一题的时候，不添加缓存数据
            onPrevious(null);
        }

        e.target.reset();
    };

    const deleteFiles = (item, index) => {
        const { partnerId } = props;
        ReviewService.deleteFile(
            item.path,
            partnerId,
            userHomeworkUnitId,
            () => {
                const newArray = [...state_uploadScoreFiles];
                newArray.splice(index, 1);
                setstate_uploadScoreFiles(newArray);
            },
            (error) => {
                MessageBox.danger({ text: error.message, duration: 5000 });
            }
        );
    };

    const checkValidScore = () => {
        triggerValidation();
        if (state_redo) {
            if (!state_reddTime || !state_redoDate) {
                MessageBox.danger({ text: t("duetimeRequired"), duration: 5000 });
                return false;
            }
        }

        let _value = getValues()["score"];
        let value = _value ? _value.trim() : "";
        let reg = /^\d{1,2}$/;
        if (!reg.test(value) && value !== "100") {
            MessageBox.danger({ text: t("scoreFieldIsRequired"), duration: 5000 });
            return false;
        }
        return true;
    };

    const _getTime = (date, type) => {
        let m = dayjs(date);
        if (m.isAfter(dayjs().endOf("day"))) {
            return new Date(type === 1 ? m.startOf("day") : m.endOf("day"));
        } else {
            m = dayjs();
            const hour = type === 1 ? m.hour() : 23;
            return new Date(m.hour(hour));
        }
    };

    const [state_editorTop, setstate_editorTop] = useState(0);
    const [state_editorBottom, setstate_editorBottom] = useState(0);
    const [state_affixWidth, setstate_affixWidth] = useState(800);
    const [state_affixHeight, setstate_affixHeight] = useState(0);
    const updateAffixTop = () => {
        if (editorViewRef.current && editorViewRef.current.clientHeight > 0) {
            const rect = editorViewRef.current.getBoundingClientRect();
            if (rect.top !== state_editorTop) {
                setstate_editorTop(rect.top);
            }
            if (rect.bottom !== state_editorBottom) {
                setstate_editorBottom(rect.bottom);
            }
        }
    };

    const updateAffixWidth = () => {
        if (affixViewRef.current && affixViewRef.current.clientWidth > 0) {
            if ((state_affixWidth !== affixViewRef.current.clientWidth) ||
                (state_affixHeight !== affixViewRef.current.clientHeight))
            {
                setstate_affixWidth(affixViewRef.current.clientWidth);
                setstate_affixHeight(affixViewRef.current.clientHeight);
            }
        }
    };

    useEffect(()=>{
        let resizeObserver = null;
        if (editorViewRef.current) {
            resizeObserver = new ResizeObserver(updateAffixTop);
            resizeObserver.observe(editorViewRef.current);
            updateAffixTop();
        }
        return () => {
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        };
    }, [editorViewRef.current]);

    useEffect(()=>{
        let resizeObserver = null;
        if (affixViewRef.current) {
            resizeObserver = new ResizeObserver(updateAffixWidth);
            resizeObserver.observe(affixViewRef.current);
            updateAffixWidth();
        }
        return () => {
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        };
    }, [affixViewRef.current]);

    const now = new Date();
    const minTime = _getTime(state_redoDate, 1);
    const maxTime = _getTime(state_redoDate, 2);
    //const showAiView = aiData && UnitAIView.hasUnitType(unitType);
    return (
        <form onSubmit={handleSubmit(handleSubmitComments)}>
            <input name="userHomeworkUnitId" hidden type="text" className="form-control" defaultValue={userHomeworkUnitId} ref={register} />
            <Row>
                <Col>
                    <div ref={editorViewRef}
                         style={{ margin: "0 auto", width: "100%", position: "relative", padding: "6px" }}>
                        <UnitAIView
                            compositionMode={true}
                            ref={aiViewRef}
                            unitType={unitType}
                            unitData={data}
                            answer={answer}
                            homeworkName={homeworkName}
                            fullName={fullName}
                            unitIndex={unitIndex}
                            width={"100%"}
                            height={525}
                            html={html}
                            data={aiData}
                            edit={state_aiEdit}
                            onChange={(data) => {
                                setstate_state_CommentData(data);
                            }}
                            reviseMode = {reviseMode}
                        />
                    </div>
                </Col>
            </Row>
            <hr style={{ marginTop: "8px", marginBottom: "8px" }} />
            <Row>
                <Col>
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                        <div style={{ alignSelf: "start", marginTop: 20, minHeight: 240, width: "100%",
                                      paddingLeft: 6, paddingRight: 6}}>
                            <div ref={affixViewRef}>
                                <ToolBarAffix style={{zIndex: 100, width: '100%',
                                                      backgroundColor: '#fff'}}
                                              minAffixBottom={state_editorBottom - 250}
                                              placement="bottom">
                                    {/*
                                    <div style={{width: state_affixWidth}}>
                                        <HtmlField formMethods={formMethods} height={260}
                                                   placeholder={props.t("commentsPlaceholder")}
                                                   fields={{
                                                       htmlContent: {
                                                           name: "comments",
                                                           value: comments.comments || "",
                                                       },
                                                       registerPayload: {
                                                           required: false,
                                                       },
                                                   }}/>
                                    </div>
                                     */}
                                    <textarea
                                        rows="4"
                                        name="comments"
                                        className="form-control-alternative form-control"
                                        placeholder={t("commentsPlaceholder")}
                                        defaultValue={comments.comments || ""}
                                        ref={register({ required: false })}
                                        style={{width: state_affixWidth, maxHeight: 300}}
                                    />
                                    <AudioElement
                                        {...props}
                                        userHomeworkUnitId={userHomeworkUnitId}
                                        audioPath={state_audioPath}
                                        onRecordStart={() => setstate_audioRecord(true)}
                                        onRecordEnd={(audioPath) => {
                                            setstate_audioPath(audioPath);
                                            setstate_audioRecord(false);
                                        }}
                                        onClear={() => setstate_audioPath("")}
                                    />
                                </ToolBarAffix>
                                <div style={{ padding: "15px 0" }}>
                                    <label className="form-control-label">{t("otherScore")}：</label>
                                    <input
                                        type="text"
                                        name="otherScore"
                                        className="form-control-alternative form-control"
                                        style={{ width: 300, display: "inline", marginRight: 5 }}
                                        defaultValue={otherScore}
                                        ref={register}
                                        placeholder={t("otherScorePlaceholder")}
                                        maxLength={500}
                                    />
                                    <input
                                        hidden
                                        type="text"
                                        name="score"
                                        className="form-control-alternative form-control"
                                        style={{ borderColor: errors.score ? "red" : "", width: 60, display: "inline", marginLeft: 30, marginRight: 5 }}
                                        //defaultValue={getDefaultScore()}
                                        value={10}
                                        ref={register({
                                            validate: {
                                                message: (_value) => {
                                                    if (state_direction === 2) {
                                                        //暂存，清空验证
                                                        return clearError();
                                                    }
                                                    if (state_previous) {
                                                        //点击上一题，清空验证
                                                        return clearError();
                                                    }
                                                    let value = _value ? _value.trim() : "";
                                                    let reg = /^\d{1,2}$/;
                                                    if (!reg.test(value) && value !== "100") {
                                                        return t("scoreFieldIsRequired");
                                                    }
                                                    return clearError();
                                                },
                                            },
                                        })}
                                    />
                                    {/*<label className="form-control-label">{t("score")}</label>*/}
                                    <Upload {...uploadScoreFileProps}>
                                        <Button type="button" style={{ marginLeft: "5px" }} color="primary" onClick={() => {}}>
                                            {t("updoadScoreFile")}
                                        </Button>
                                    </Upload>
                                    <div>
                                        {state_uploadScoreFiles
                                            ? state_uploadScoreFiles.map((item, i) => {
                                                  const maxWidth = props.width ? props.width - 120 : 200;
                                                  return (
                                                      <div key={i}>
                                                          <div>
                                                              <a
                                                                  target="_blank"
                                                                  href={Helper.convertToFileServerPath(item.path)}
                                                                  style={{
                                                                      whiteSpace: "nowrap",
                                                                      textOverflow: "ellipsis",
                                                                      maxWidth: maxWidth,
                                                                      overflow: "hidden",
                                                                      marginBottom: 8,
                                                                      color: "#3179f4",
                                                                      marginRight: 4,
                                                                  }}
                                                                  rel="noreferrer">
                                                                  {item.name}
                                                              </a>
                                                              <a href="javascript:void(0)" onClick={() => deleteFiles(item, i)} style={{ marginLeft: 4, color: "red", fontSize: "22px" }}>
                                                                  <Icon type="close" />
                                                              </a>
                                                          </div>
                                                          <div>
                                                              {!item.path.match(/\.(jpg|jpeg|png|gif)$/i) ? null : (
                                                                  <a target="_blank" href={Helper.convertToFileServerPath(item.path)} style={{ marginTop: 4, display: "block" }} rel="noreferrer">
                                                                      <img src={Helper.convertToFileServerPath(item.path)} style={{ maxWidth: "100%" }} alt={item.name} />
                                                                  </a>
                                                              )}
                                                          </div>
                                                      </div>
                                                  );
                                              })
                                            : null}
                                    </div>
                                    {/*<label className="form-control-label" style={{ fontSize: 13, marginLeft: 10, color: "#67779F" }}>
                                        {t("scoreRange")}
                                    </label>*/}
                                </div>
                            </div>
                        </div>
                        <div style={{ alignSelf: "start", marginTop: 20, width: "100%" }}>
                            <Checkbox defaultChecked={state_redo} onChange={(e) => setstate_redo(e.target.checked)}>
                                <label className="form-control-label">{t("reWriteComp")}</label>
                            </Checkbox>
                            {state_redo ? (
                                <div className="form-group form-inline mb-0 pt-2 pb-2">
                                    <label className="form-control-label">{t("reWriteCompEndTime")}</label>
                                    <div style={{ display: "flex" }} className="ml-2">
                                        <div>
                                            <DatePicker
                                                placeholderText={t("selectDate")}
                                                title={t("selectDate")}
                                                selected={state_redoDate}
                                                minDate={now}
                                                onChange={(date) => setstate_redoDate(date)}
                                                dateFormat="yyyy/MM/dd"
                                                disabled={!state_redo}
                                            />
                                        </div>
                                        <div style={{ marginLeft: 20 }}>
                                            <DatePicker
                                                placeholderText={t("selectTime")}
                                                title={t("selectTime")}
                                                selected={state_reddTime}
                                                onChange={(date) => setstate_reddTime(date)}
                                                timeIntervals={60}
                                                minTime={minTime}
                                                maxTime={maxTime}
                                                showTimeSelect
                                                showTimeSelectOnly
                                                dateFormat="h:mm:ss aa"
                                                disabled={!state_redoDate || !state_redo}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        <HistoryPart {...props} />
                        <div style={{ margin: "20px auto" }}>
                            {unit.revisedOn || unit.justRevisedOn ? null : (
                                <Button
                                    color="primary"
                                    onClick={() => {
                                        setstate_direction(2);
                                    }}>
                                    {t("temporarySave")}
                                </Button>
                            )}
                            {unitIndex > 0 && (
                                <Button
                                    color="primary"
                                    onClick={() => {
                                        //checkValidScore();
                                        //点击上一题的时候，不验证数据
                                        setstate_previous(true);
                                        setstate_direction(-1);
                                    }}>
                                    {t("previous")}
                                </Button>
                            )}
                            {unitIndex < unitCount && (
                                <Button
                                    color="primary"
                                    disabled={state_uploading}
                                    onClick={() => {
                                        if (checkValidScore()) {
                                            setstate_direction(1);
                                        }
                                    }}>
                                    {t(unitIndex + 1 === unitCount ? "complete" : "next")}
                                </Button>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>
            <input ref={submitRef} type="submit" hidden />
        </form>
    );
};

const PeerReviseMode = (props) => {
    const { t } = useTranslation(uid);
    const { onPrevious, onNext, unit, unitIndex, unitCount, reviseMode, fullName, homeworkName } = props;

    const { userHomeworkUnitId, unitType, cover, score, answer, files, childUnitIndex, isSubjective, needRevise } = unit;
    const { comments, unitScreenShot, audioPath, aiData, text, html, history, scoreFile } = unit.comments ? JSON.parse(unit.comments) : "" || {};
    const data = { ...unit.data, userHomeworkUnitId, childUnitIndex };
    const result = answer ? { score, answer: JSON.parse(answer), files: JSON.parse(files) } : null;

    const submitAiScoreRef = useRef();
    const { register, handleSubmit, errors, clearError } = useForm();

    return (
        <form onSubmit={handleSubmit(props.onSaveAiScore)}>
            <input name="userHomeworkUnitIdAiScore" hidden type="text" className="form-control" defaultValue={userHomeworkUnitId} ref={register} />
            <Row>
                <Col>
                    <div style={{ margin: "0 auto", width: "100%" }}>
                        <UnitAIView
                            compositionMode={true}
                            unitType={unitType}
                            unitData={data}
                            answer={answer}
                            homeworkName={homeworkName}
                            fullName={fullName}
                            unitIndex={unitIndex}
                            width={"100%"}
                            //height={525}
                            data={aiData}
                            readonly={true}
                            reviseMode = {reviseMode}
                        />
                    </div>
                </Col>
            </Row>
            <hr style={{ marginTop: "8px", marginBottom: "8px" }} />
            <Row>
                <Col>
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                        <ReviseDetail {...props} />
                        <div style={{ margin: "20px auto" }}>
                            {unitIndex > 0 && (
                                <Button color="primary" onClick={() => onPrevious()}>
                                    {t("previous")}
                                </Button>
                            )}
                            {unitIndex + 1 === unitCount ? null : (
                                <Button color="primary" onClick={() => onNext()}>
                                    {t(unitIndex + 1 === unitCount ? "complete" : "next")}
                                </Button>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>
            <input ref={submitAiScoreRef} type="submit" hidden />
        </form>
    );
};

const WrapperCommentsForm = (props) => {
    const { homeworkStatus, reviseMode, unit } = props;
    const { score, endOn, revisedOn, needRevise, justRevisedOn } = unit;

    if (reviseMode === 1) {
        return <PeerReviseMode {...props} />;
    } else {
        // 待修改的作文, 只显示历史批阅
        if (score === -2 && (homeworkStatus < 2)) {
            return <CommentsDetails historyOnly={(homeworkStatus < 2)} {...props} />;
        }

        //作文单元批阅过了的 重做再进来的时候显示只读
        if (needRevise && (!revisedOn || justRevisedOn) && (homeworkStatus >= 2)) {
            return <CommentsForm {...props} />;
        } else {
            return <CommentsDetails {...props} />;
        }
    }
};
const WrapperCommentsDetails = (props) => {
    const { homeworkStatus, reviseMode } = props;
    return reviseMode === 1 ? <PeerReviseMode {...props} /> : <CommentsDetails historyOnly={(homeworkStatus < 2)} {...props} />;
};

function AudioElement(props) {
    const { audioPath, t, onRecordStart, onRecordEnd, onClear } = props;
    const audioRecorder = useRef();
    const [state_showAudio, setstate_showAudio] = useState(!!audioPath);
    useEffect(()=>{
        // NOTE: safari浏览器当录完音立即显示audio会有问题, 此处延迟显示
        let id = setTimeout(() => {setstate_showAudio(!!audioPath)}, 500);
        return ()=>clearTimeout(id);
    }, [audioPath]);

    const handleRecordEnd = (blob) => {
        // let tempPath = window.URL.createObjectURL(blob)
        const file = new File([blob], "recordFile.mp3");
        const { userId, partnerId, userHomeworkUnitId } = props;
        const now = new Date();
        const uploadPath = `${Constants.FILE_STORAGE.TEMP_PATH}users/${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}/${userId}/${userHomeworkUnitId}`;
        ReviewService.uploadAudio(
            file,
            uploadPath,
            partnerId,
            (response) => {
                const { virtualPath } = response;
                onRecordEnd(virtualPath);
            },
            (error) => {
                MessageBox.danger({ text: error.message, duration: 5000 });
            }
        );
    };

    return (
        <div style={{ padding: "15px 0", display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            {Helper.isNullOrEmpty(audioPath) ? (
                <div style={{ padding: "0 15px" }}>
                    <AudioRecorder
                        ref={audioRecorder}
                        encodeFormat='mp3'
                        onRecordError={(error) => {
                            if (error) {
                                error && MessageBox.danger({ text: error.message, duration: 5000 });
                            }
                        }}
                        onRecordStart={onRecordStart}
                        onRecordEnd={handleRecordEnd}
                        enablePause={true}
                        pauseTip={t("pauseTip")}
                        resumeTip={t("resumeTip")}
                        startTip={t("startTip")}
                        endTip={t("endTip")}
                    />
                </div>
            ) : (
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <div style={{ float: "left", marginTop: 5, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                     {state_showAudio ?
                       (<audio controls type="audio/mpeg" src={Helper.convertToFileServerPath(audioPath)}>
                            Your browser does not support the audio element.
                        </audio>) : null}
                    </div>
                    <div style={{ display: "flex" }}>
                        <button
                            type="button"
                            className="btn btn-warning"
                            style={{ marginLeft: 5, marginTop: 5 }}
                            onClick={() => {
                                onClear();
                                setTimeout(() => {
                                    audioRecorder.current._handleRecordStart();
                                }, 0);
                            }}>
                            {t("redo")}
                        </button>
                        <button type="button" className="btn btn-danger" style={{ marginLeft: 5, marginTop: 5 }} onClick={onClear}>
                            {t("delete")}
                        </button>
                        <Button
                            style={{marginLeft: 5, marginTop:5}}
                            color="primary"
                            onClick={()=>{Helper.downloadFile(Helper.convertToFileServerPath(audioPath), Helper.getLastFileName(audioPath))}}
                        >
                            {t("download")}
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
}

export { WrapperCommentsDetails as CommentsDetails, WrapperCommentsForm as CommentsForm };
